import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

// Types
interface PublicRouteProps {
  children: ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = (): boolean => {
    return !!localStorage.getItem("authToken");
  };

  if (isAuthenticated()) {
    return <Navigate to={"/dashboard-360"} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
